import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {
  FaUndo,
} from 'react-icons/fa';
import {
  Button,
  ButtonGroup,
  ToolTip,
  withContext,
} from '../../../../components';
import { Consumer } from '../../Context';

const propTypes = {
  context: PropTypes.shape({
    onAddRow: PropTypes.func.isRequired,
    onAddColumn: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    categoryName: PropTypes.string.isRequired,
    categoryBenefits: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.string,
      category: PropTypes.string,
      subcategory: PropTypes.string,
    })),
  }).isRequired,
};

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
function CategoryLayoutButtons(props) {
  const {
    context: {
      onAddRow,
      onAddColumn,
      onReset,
      categoryBenefits,
      categoryName,
    },
  } = props;
  const showAddRowButton = categoryBenefits.every(categoryBenefit => categoryBenefit.name !== '');
  const showAddColumnButton = categoryBenefits.every(categoryBenefit => categoryBenefit.subcategory !== '');
  const showResetButton = categoryBenefits
    .some(categoryBenefit => categoryBenefit.id === undefined);
  return (
    <ButtonContainer>
      <ButtonGroup>
        <ToolTip content="Fill the empty row before adding a new row" disabled={showAddRowButton}>
          <Button onClick={() => onAddRow(categoryName)} disabled={!showAddRowButton}>
            Add Row
          </Button>
        </ToolTip>
        <ToolTip content="Fill the empty column before adding a new column" disabled={showAddColumnButton}>
          <Button onClick={() => onAddColumn(categoryName)} disabled={!showAddColumnButton}>
            Add Column
          </Button>
        </ToolTip>
      </ButtonGroup>
      {(showResetButton)
              && (
                <ToolTip content="Resets to initial state.">
                  <Button
                    iconStart={<FaUndo />}
                    onClick={() => onReset(categoryName)}
                  />
                </ToolTip>

              )}
    </ButtonContainer>
  );
}
CategoryLayoutButtons.propTypes = propTypes;
export default withContext(Consumer)(CategoryLayoutButtons);
